var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-photos"},_vm._l((_vm.posts),function(post){return _c('a',{staticClass:"photo-post",attrs:{"href":'/#/photoalbums/' + post.slug}},[_c('div',{staticClass:"inside"},[_c('img',{attrs:{"src":post.cover}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(post.name))]),_vm._v(" "),_c('i',[_vm._v(_vm._s(post.date_time))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ada65e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/photo-report.vue
// module id = 32
// module chunks = 0